(() => {
  const PROXY_ENDPOINT = "/apps/preferiti";

  const sendToProxy = async (action, payload) => {
    const response = await fetch(PROXY_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        product_id: payload.id,
        action: action,
      }),
    });
    if (!response.ok) throw new Error(`HTTP error. status: ${response.status}`);
    const { items } = await response.json();
    return items;
  };

  const uniq = (arr) => Array.from(new Set(arr));

  const fetchCardHTML = async ({ handle, fragmentSectionId }) => {
    const url = `/products/${encodeURIComponent(handle)}?sections=${encodeURIComponent(fragmentSectionId)}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
    const json = await res.json();
    return json[fragmentSectionId] || "";
  };

  const toElements = (html) => {
    const wrap = document.createElement("div");
    wrap.innerHTML = html.trim();

    const shopifyWrapper = wrap.querySelector(".shopify-section");
    if (shopifyWrapper) {
      return Array.from(shopifyWrapper.children);
    }
    return Array.from(wrap.children);
  };

  const renderWishlist = async (root) => {
    let items = [];


    try {
      items = JSON.parse(root.dataset.wishlistItems || "[]");
    } catch (e) {
      console.error("Errore parsing items:", e);
    }

    const fragmentSectionId =
      root.dataset.wishlistFragmentSection || "wishlist-product-card";
    const limit = Number(root.dataset.wishlistLimit || 24);
    const sectionEl =
      root.closest(".shopify-section") ||
      root.closest("[id^='shopify-section-']");

    if (sectionEl) sectionEl.classList.add("is-loading");

    const handles = uniq(
      (Array.isArray(items) ? items : [])
        .map((x) => {
          if (typeof x === "object" && x !== null && x.handle) return x.handle;
          if (typeof x === "string") return x;
          return null;
        })
        .filter(Boolean),
    ).slice(0, limit);

    if (!handles.length) {
      if (sectionEl) {
        sectionEl.classList.remove("is-loading");
        sectionEl.classList.add("is-empty");
      }
      return;
    }

    if (sectionEl) sectionEl.classList.remove("is-empty");
    const frag = document.createDocumentFragment();

    for (const handle of handles) {
      try {
        const html = await fetchCardHTML({ handle, fragmentSectionId });

        const els = toElements(html);
        els.forEach((el) => frag.appendChild(el));
      } catch (e) {
        console.error(`Errore nel fetch per l'handle ${handle}:`, e);
      }
    }

    root.innerHTML = "";
    root.appendChild(frag);

    if (sectionEl) sectionEl.classList.remove("is-loading");
  };

  const init = () => {
    document.querySelectorAll("[data-wishlist-grid]").forEach((grid) => {
      renderWishlist(grid);

      grid.addEventListener("click", async (e) => {
        const removeBtn = e.target.closest("[data-wishlist-remove]");
        if (!removeBtn) return;

        e.preventDefault();
        const productId = removeBtn.dataset.productId;
        if (!productId) return;

        const card = removeBtn.closest(".js-grid > div");

        removeBtn.setAttribute("disabled", "true");
        removeBtn.style.opacity = "0.5";

        try {
          const updatedItems = await sendToProxy("remove", { id: productId });
          grid.dataset.wishlistItems = JSON.stringify(updatedItems);

          if (card) {
            card.style.transition = "all 0.3s ease";
            card.style.opacity = "0";
            card.style.transform = "scale(0.9)";

            setTimeout(() => {
              card.remove();

              if (grid.children.length === 0) {
                const sectionEl =
                  grid.closest(".shopify-section") ||
                  grid.closest("[id^='shopify-section-']");
                if (sectionEl) {
                  sectionEl.classList.add("is-empty");
                }
              }
            }, 300);
          }
        } catch (error) {
          console.error("Errore durante la rimozione del prodotto:", error);
          removeBtn.removeAttribute("disabled");
          removeBtn.style.opacity = "1";
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", init);
})();
